import { Components, Theme } from '@mui/material';

export function getMuiAccordionSummary(
  theme: Theme,
): Components['MuiAccordionSummary'] {
  return {
    styleOverrides: {
      root: {
        padding: 0,
      },

      content: {
        margin: theme.spacing(2, 0),
      },

      expandIconWrapper: {
        '&.Mui-expanded': {
          transform: 'rotate(135deg)',
        },
      },
    },
  };
}
